function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.75 12.75c0 .688.563 1.25 1.25 1.25.695 0 1.25-.563 1.25-1.25 0-.688-.555-1.25-1.25-1.25-.688 0-1.25.563-1.25 1.25zm2.258-3.172v-.062c1.797-.368 3.14-1.688 3.14-3.235 0-1.96-1.914-3.57-4.187-3.57-1.117 0-2.164.352-2.945 1.008-.25.203-.36.594-.36.75 0 .554.532 1.039 1.086 1.039.242 0 .477-.086.664-.235.407-.328.961-.507 1.563-.507 1.117 0 2.101.703 2.101 1.492v.015c-.015.805-.945 1.461-2.086 1.461-.53 0-1.007.446-1.007.938l.015.906c.008.508.461.922 1.008.922.555 0 1-.414 1.008-.922zM0 8a8 8 0 018-8c4.422 0 8 3.578 8 8 0 4.422-3.578 8-8 8a8 8 0 01-8-8z"
});

var SvgQuestionIcon = function SvgQuestionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -4 22 22",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgQuestionIcon;